import { Skeleton } from "@st-marketplace/ui";

export const InputSkeleton = () => (
	<Skeleton className="h-11.5 w-full rounded-md" />
);

export const TwoInputSkeleton = () => (
	<div className="flex flex-col gap-5 sm:flex-row">
		<div className="w-full">
			<InputSkeleton />
		</div>
		<div className="w-full">
			<InputSkeleton />
		</div>
	</div>
);
